<button *ngFor="let preset of presets"
        (click)="valueChange.emit(preset.date)"
        class="preset"
        [class.active]="preset.date === value"
        #presetContent
        [attr.title]="presetContent.textContent">
  {{preset.label}} <span class="preset-tooltip">({{preset.tooltip}})</span>
</button>
